import { render, staticRenderFns } from "./TimeDuration.vue?vue&type=template&id=4c10657e&scoped=true&"
import script from "./TimeDuration.vue?vue&type=script&lang=js&"
export * from "./TimeDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c10657e",
  null
  
)

export default component.exports